/* eslint-disable import/prefer-default-export */
import React from "react";
import styled from "styled-components";
import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper, ButtonSizeOptions, MaterialIcon } from "@loanbossinc/component-library";

import { shouldShowRepaymentTermEdit } from "./section-loan-forbearance-rows-logic";

const StyledCustomFieldHeader = styled.span`&& {
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;  
  text-transform: uppercase;  
  color: #5F6368;
  vertical-align: super;
}`;

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Forbearance",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.forbearance.header"
      }
    ]
  },
  effectiveDate: {
    label: "Effective Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "forbearance.effectiveDate",
        variant: "filled"
      }
    ]
  },
  paymentDeferralStartDate: {
    label: "Payment Deferral Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "forbearance.paymentDeferralStartDate",
        variant: "filled"
      }
    ]
  },
  paymentDeferralEndDate: {
    label: "Payment Deferral End Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "forbearance.paymentDeferralEndDate",
        variant: "filled"
      }
    ]
  },
  deferralRepaymentConditionId: {
    label: "Deferral Repayment Condition",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "deferralRepaymentCondition",
        name: "forbearance.deferralRepaymentConditionId",
        variant: "filled",
        parentId: "deferralRepaymentConditions",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  repaymentTerm: {
    isVisible: data => shouldShowRepaymentTermEdit(data),
    label: "Repayment Term (Months)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "forbearance.repaymentTerm",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "forbearance.appliesToId",
        label: "Applies To",
        variant: "filled",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        style: { marginTop: "10px", marginLeft: "0" },
        options: [
          { name: "Principal and interest", id: "5549f3bb-963e-11eb-bc1a-00ffdc22d1cc" },
          { name: "Interest only", id: "867cddcd-9642-11eb-bc1a-00ffdc22d1cc" }
        ]
      }
    ]
  },
  totalDeferred: {
    label: "Total Deferred",
    variant: "filled",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "forbearance.totalDeferred",
        decimals: 2,
        variant: "filled"
      }
    ]
  },
  covenants: {
    label: "Covenants",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "forbearance.covenants",
        variant: "filled",
        multiline: true
      }
    ]
  },
  reporting: {
    label: "Reporting",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "forbearance.reporting",
        variant: "filled",
        multiline: true
      }
    ]
  },
  depositsAndReserves: {
    label: "Deposits And Reserves",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "forbearance.depositsAndReserves",
        variant: "filled",
        multiline: true
      }
    ]
  },
  distributionRestrictions: {
    label: "Distribution Restrictions",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "forbearance.distributionRestrictions",
        variant: "filled",
        multiline: true
      }
    ]
  },
  /*
   * cashManagement: {
   *   label: 'Cash Management',
   *   cells: [
   *     {
   *       type: FORM_BUILDER_FIELD_TYPE.STRING,
   *       name: "forbearance.cashManagement",
   *       variant: "filled",
   *       multiline: true
   *     }
   *   ],
   * },
   */

  customField: {
    hasNestedRows: true,
    isDragable: true,
    key: "forbearance.loanForbearanceCustom",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TEXT,
              value: (<>
                <MaterialIcon iconName={"drag_indicator"} />
                <StyledCustomFieldHeader>{`custom field ${index + 1}`}</StyledCustomFieldHeader>
              </>),
              style: { marginLeft: 0 }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          { map: index => ({ type: FORM_BUILDER_FIELD_TYPE.STRING,
            label: "Custom Field Name",
            name: `forbearance.loanForbearanceCustom[${index}].name`,
            variant: "filled",
            multiline: true,
            style: { marginTop: "10px", marginLeft: "0" } }) },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove Custom Field",
              hasBorder: false,
              size: ButtonSizeOptions.smFluid,
              name: `forbearance.loanForbearanceCustom[${index}].id`,
              style: { width: "214px", marginTop: "10px", float: "right", border: "none" },
              onClick: (value, formik) => {
                const forbearance = formik.values.forbearance;
                let loanForbearanceCustom = formik.values.forbearance.loanForbearanceCustom;
                if (value !== null) {
                  loanForbearanceCustom = loanForbearanceCustom.filter(loanForbearanceCustom => loanForbearanceCustom.id !== value);
                } else {
                  loanForbearanceCustom = loanForbearanceCustom.splice(index, 1);
                }
                forbearance.loanForbearanceCustom = loanForbearanceCustom;
                formik.setValues({ ...formik.values, forbearance });
              }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.STRING,
              label: "Enter Text",
              name: `forbearance.loanForbearanceCustom[${index}].value`,
              variant: "filled",
              style: { marginTop: "10px", marginLeft: "0" },
              multiline: true
            })
          }
        ]
      }
    ]
  },

  addRecord: {
    key: "addRecord",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON_PRIMARY,
        label: "Add Field",
        hideLabel: true,
        size: ButtonSizeOptions.sm,
        onClick: (value, formik) => {
          let forbearance = formik.values.forbearance;
          if (!forbearance) {
            forbearance = { id: "new", loanForbearanceCustom: [] };
          }
          if (forbearance && !forbearance.loanForbearanceCustom) {
            forbearance.loanForbearanceCustom = [];
          }

          const sortOrder = formik.values.forbearance && formik.values.forbearance.loanForbearanceCustom ? formik.values.forbearance.loanForbearanceCustom.length + 1 : 1;
          const newForbearanceCustomRow = {
            id: "new",
            loanForbearanceId: forbearance.id,
            name: null,
            value: null,
            sortOrder
          };

          if (!formik.values.forbearance || !formik.values.forbearance.loanForbearanceCustom) {
            forbearance.loanForbearanceCustom.push(newForbearanceCustomRow);
          } else {
            forbearance.loanForbearanceCustom.splice(formik.values.forbearance.loanForbearanceCustom.length, 0, newForbearanceCustomRow);
          }

          formik.setValues({ ...formik.values, forbearance });
        },
        style: { width: "132px", marginTop: "10px", float: "right" }
      }
    ]
  }

};
